/**
 * The staged product panel's main Save starts from the pencil-edit draft.
 * Launch dates and lifecycle live in their own cards and join that payload
 * only when the card reports a pending edit (`undefined` means unchanged).
 */
export function withCardPending(
  editData: Record<string, unknown>,
  pendingLaunchDates: unknown,
  pendingLifecycle: unknown,
): Record<string, unknown> {
  const payload: Record<string, unknown> = { ...editData };
  if (pendingLaunchDates !== undefined) payload.launchDates = pendingLaunchDates;
  if (pendingLifecycle !== undefined) payload.lifecycle = pendingLifecycle;
  return payload;
}
